import { z } from 'zod';

/**
 * Endereço (CEP lookup + validation) shared contracts.
 *
 * Used by the API (`GET /enderecos/cep/:cep`, `422 address_mismatch`) and the
 * Angular wizard, so both sides speak the exact same shapes.
 *
 * Privacy: only the CEP (public, non-PII) is ever sent to third-party lookup
 * providers — never the free-text endereço.
 */

export const CepParamSchema = z.object({
  cep: z.string().regex(/^\d{8}$/, 'CEP inválido'),
});

export const CepLookupResultSchema = z.object({
  cep: z.string().regex(/^\d{8}$/),
  logradouro: z.string().nullable(),
  bairro: z.string().nullable(),
  cidade: z.string(),
  uf: z.string().regex(/^[A-Z]{2}$/),
});

export const AddressIssueSchema = z.object({
  field: z.enum(['cep', 'cidade', 'uf', 'endereco']),
  code: z.enum(['cep_not_found', 'cidade_mismatch', 'uf_mismatch', 'logradouro_mismatch']),
  /** What the CEP says. */
  expected: z.string().optional(),
  /** What the user typed. */
  actual: z.string().optional(),
  /** cep/cidade/uf mismatches are errors; logradouro is a soft warning. */
  severity: z.enum(['error', 'warning']),
});

export type CepParam = z.infer<typeof CepParamSchema>;
export type CepLookupResult = z.infer<typeof CepLookupResultSchema>;
export type AddressIssue = z.infer<typeof AddressIssueSchema>;
